/*
  FILM GALLERY V3 - JS OVERHAUL
  Namespace: fg-
*/

console.log('Film Gallery V3 Script Loaded - Version check');

$(document).ready(function () {
    // ── Chrome mobile fix: lock document scroll and use #PageContainer ──
    // Chrome only hides its address bar on document scroll (not element scroll).
    // By locking html/body and scrolling inside #PageContainer, the bar stays
    // permanently visible, so position:fixed elements (lightbox) never have gaps.
    // Only apply on mobile — on desktop this would prevent scrolling to the bottom.
    if (window.innerWidth < 768) {
        document.documentElement.classList.add('fg-scroll-lock');
    }

    // ===== TEST FLAG: Uncomment to test ownership states =====
    // Options: 'UNCLAIMED' | 'OWNED_BY_CURRENT_USER' | 'OWNED_BY_OTHER' | 'LINKED_TO_CURRENT_USER'
    //const TEST_OWNERSHIP_STATE = 'LINKED_TO_CURRENT_USER';
    const TEST_OWNERSHIP_STATE = null; // Set to null to use real data
    // ==========================================================

    const config = window.FilmGalleryConfig || {};

    function initHoverButtons(container) {
        if (window.theme && window.theme.HoverButton) {
            $(container).find('.button').each(function() {
                new window.theme.HoverButton(this).load();
            });
        }
    }

    const customerId = config.customerId;
    let labServiceId = config.labServiceId;
    let isFilmOwner = false; // Global State for Ownership
    let isCollection = false; // True when viewing a custom collection

    // Fallback: Check URL for Lab Service ID (passed as query param or part of URL)
    if (!labServiceId) {
        const urlParams = new URLSearchParams(window.location.search);
        // Try getting the first param key as the ID if no value, or specific keys like 'id'
        // Based on user log: ?An6Sr6ze... -> The key might be the ID, or the value
        // Assuming common pattern ?id=... or just ?...

        // Strategy: Look for a UUID-like string or the first query key if it looks like an ID
        // The user log showed: ?An6Sr6ze6jNg=01993333-5eae-7fd4-89ac-f63053dabffc
        // It seems the value of the first param is the UUID.

        for (const [key, value] of urlParams) {
            if (value && value.length > 20) { // simplistic UUID check
                labServiceId = value;
                break;
            }
        }
    }

    // Allow initialization without customerId (Guest Access)
    if (!labServiceId) {
        console.warn('FilmGallery: Configuration missing. LabService:', labServiceId);
        // Customer ID is optional for public galleries (Guest Access)
        $('.fg-status-container').removeClass('fg-hidden').html(`
            <h3>Konfiguration fehlt</h3>
            <p>Der Link scheint unvollständig zu sein (Keine LabService ID).</p>
        `);
        $('#fg-loading').hide();
        return;
    }

    // Update Prints Button Deep Link
    if (labServiceId) {
        const $printsBtn = $('#fg-prints-btn');
        if ($printsBtn.length) {
            const currentHref = $printsBtn.attr('href').split('?')[0];
            $printsBtn.attr('href', `${currentHref}?film_id=${labServiceId}`);
        }
    }

    // --- STATE ---
    let currentPage = 1;
    let isLoading = false;
    let hasMoreImages = true;
    let allImages = [];
    const imagesPerPage = 50;

    // --- SELECTORS ---
    const $grid = $('#fg-grid');
    const $loadingOverlay = $('#fg-loading');
    const $statusContainer = $('#fg-status-container');
    const $downloadBtn = $('#fg-download-btn');
    const $title = $('.fg-title');
    const $date = $('.fg-date');
    const $metaGrid = $('.fg-metadata-grid');
    const $doctorContainer = $('#film-doctor-container');

    // --- ISSUES CONFIGURATION ---
    // Issue codes are now defined in film-issues-config.js
    // This allows easy editing without touching the main gallery code
    const FILM_ISSUES = window.FILM_ISSUE_CODES || {};

    console.log('FILM_ISSUES loaded:', Object.keys(FILM_ISSUES).length, 'codes');
    console.log('window.FILM_ISSUE_CODES available:', !!window.FILM_ISSUE_CODES);


    // --- UTILS ---
    const getFilename = (url) => {
        if (!url) return '';
        // Extract filename and strip query params
        let filename = url.substring(url.lastIndexOf('/') + 1);
        return filename.split('?')[0];
    };

    // --- API & DATA FETCHING ---

    // Fetch Issue Code Mapping
    async function fetchIssueCodeMapping() {
        try {
            const response = await fetch('https://backend.wiederfaenger.ch/issue_codes');
            if (!response.ok) {
                console.warn('Issue codes fetch failed:', response.status);
                return {};
            }
            const data = await response.json();
            const mapping = {};
            data.forEach(code => mapping[code.id] = code.name);
            return mapping;
        } catch (e) {
            console.error('Issue mapping fetch error:', e);
            return {};
        }
    }

    // Issue texts v2 (codes INTAKE_… / LAB_…) from the backend, used for codes that
    // film-issues-config.js does not know. Before the backend has /film_issues this stays empty.
    let filmIssuesV2 = null;
    function fetchFilmIssuesV2() {
        if (!filmIssuesV2) {
            filmIssuesV2 = fetch('https://backend.wiederfaenger.ch/film_issues')
                .then(res => (res.ok ? res.json() : { codes: [] }))
                .then(data => {
                    const byCode = {};
                    (data.codes || []).forEach(c => byCode[c.code] = c);
                    return byCode;
                })
                .catch(() => ({}));
        }
        return filmIssuesV2;
    }

    // Same shape as film-issues-config.js; the customer note replaces the text of the note codes
    function issueInfoV2(def, issue) {
        const note = def.usesNote && issue.customer_note ? $('<div>').text(issue.customer_note).html() : null;
        return {
            severity: def.level === 'warning' ? '🟠' : '🔵',
            title: def.title,
            description: note || def.description,
            causes: def.causes || [],
            prevention: def.tips || [],
            helpUrl: def.helpUrl
        };
    }

    async function loadGallery(page = 1) {
        if (isLoading) return;
        isLoading = true;

        try {
            const response = await fetch(`https://backend.wiederfaenger.ch/images/${customerId || 0}/${labServiceId}?page=${page}&per_page=${imagesPerPage}`);

            if (response.status === 403 || response.status === 401 || response.status === 400) {
                console.log('Access denied, status:', response.status);
                await handleAccessDenied();
                return;
            }

            if (!response.ok) throw new Error('Failed to fetch gallery');

            const data = await response.json();

            // Debug API Structure
            if (data.images && data.images.length > 0) {
                console.warn('API IMAGE STRUCTURE:', data.images[0]);
            } else {
                console.warn('API returned no images or invalid structure', data);
            }

            // Override Ownership/Status for Testing (Code Flag)
            if (TEST_OWNERSHIP_STATE) {
                console.warn('🎭 TEST MODE - Ownership Override:', TEST_OWNERSHIP_STATE);
                data.ownership_state = TEST_OWNERSHIP_STATE;
            }

            // Initial Setup
            if (page === 1) {
                updateGalleryInfo(data);
                handleStatus(data);
                await handleFilmDoctor(data);

                // Visibility Modal Init
                if (data.visibility) {
                    $(`.fg-radio-option input[value="${data.visibility}"]`).prop('checked', true);
                }
            }

            // Image Rendering
            if (data.images && data.images.length > 0) {
                allImages = allImages.concat(data.images);
                hasMoreImages = data.images.length === imagesPerPage;
                await renderImages(data.images); // Render new items in received order
                $downloadBtn.removeAttr('disabled');
            } else {
                hasMoreImages = false;
                if (page === 1 && !data.status) { // Only if really empty and not status-hidden
                    $grid.html('<div class="fg-status-card">Keine Bilder gefunden.</div>');
                }
            }

            // Infinite Scroll Setup (only once)
            if (page === 1 && hasMoreImages) {
                setupInfiniteScroll();
            }

        } catch (error) {
            console.error('Gallery Load Error:', error);
            // Optional: Show error state
        } finally {
            isLoading = false;
            $loadingOverlay.fadeOut();
            $('.fg-container').removeClass('fg-hidden'); // Show container
        }
    }

    // --- UI UPDATES ---

    function updateGalleryInfo(data) {

        // --- GLOBAL METADATA FOR DOWNLOADS ---
        // Store title and date globally so the download handler can access them even if DOM is modified
        let filenameDate = '';
        let displayDate = '';
        
        let parsedDate = null;
        if (data.lab_date) {
            parsedDate = new Date(data.lab_date);
            if (isNaN(parsedDate.getTime()) && typeof data.lab_date === 'string' && data.lab_date.includes('.')) {
                const parts = data.lab_date.split('.');
                if (parts.length === 3) {
                    parsedDate = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
                }
            }
        }
        
        if (parsedDate && !isNaN(parsedDate.getTime())) {
            filenameDate = parsedDate.toISOString().split('T')[0];
            displayDate = parsedDate.toLocaleDateString('de-DE');
        } else if (data.formatted_custom_created_at) {
            // Try to parse DD.MM.YYYY
            const parts = data.formatted_custom_created_at.split('.');
            if (parts.length === 3) filenameDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
            displayDate = data.formatted_custom_created_at;
        }

        window.galleryMetadata = {
            title: data.name || 'Unbenannter Film',
            date: displayDate,
            filenameDate: filenameDate || new Date().toISOString().split('T')[0], // Fallback to today YYYY-MM-DD
            visibility: data.visibility || 'PRIVATE'
        };

        console.log('Global Metadata Set:', window.galleryMetadata);

        // Update Title
        if (window.galleryMetadata.title.toLowerCase() === 'favoriten') {
            $('.fg-title').html(`<span style="display: inline-flex; align-items: center; gap: 8px;"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-heart-icon lucide-heart" style="flex-shrink: 0;"><path d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"/></svg>${window.galleryMetadata.title}</span>`);
        } else {
            $('.fg-title').text(window.galleryMetadata.title);
        }

        // Update Back Link based on collection type
        isCollection = data.collection_kind === 'CUSTOM' || data.service_type === 'CUSTOM';
        const $backLink = $('.fg-back-link');
        if (isCollection) {
            $backLink.attr('href', (window.FilmGalleryConfig.routes.root_url || '/') + 'pages/deine-sammlungen');
            $backLink.find('span').text('Alle Sammlungen');
        } else {
            $backLink.attr('href', (window.FilmGalleryConfig.routes.root_url || '/') + 'pages/films-collection');
            $backLink.find('span').text('Alle Filme');
        }

        // Update Global Ownership
        isFilmOwner = data.is_owner === true;

        const metaParts = [];
        const tagParts = []; // Separate array for tags

        if (data.film_type) metaParts.push(data.film_type.toUpperCase());

        if (data.lab_date) {
            let parsedMetaDate = new Date(data.lab_date);
            if (isNaN(parsedMetaDate.getTime()) && typeof data.lab_date === 'string' && data.lab_date.includes('.')) {
                const parts = data.lab_date.split('.');
                if (parts.length === 3) parsedMetaDate = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
            }
            if (!isNaN(parsedMetaDate.getTime())) {
                metaParts.push(parsedMetaDate.toLocaleDateString('de-DE', {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric'
                }));
            } else {
                metaParts.push(data.lab_date);
            }
        } else if (data.formatted_custom_created_at) {
            metaParts.push(data.formatted_custom_created_at);
        }

        // Frame Count with Tooltip
        if (data.scanned_frames !== undefined && data.scanned_frames !== null) {
            const framesText = data.nominal_frames
                ? `${data.scanned_frames} / ${data.nominal_frames} BILDER`
                : `${data.scanned_frames} BILDER`;

            // Add tooltip if there's a nominal count (to explain variance)
            if (data.nominal_frames) {
                const tooltipText = 'Bei analogem Film kann die Anzahl entwickelter Bilder variieren. Je nach Kamera, Filmtransport und Entwicklung sind es manchmal mehr oder weniger als die angegebene Anzahl auf dem Film.';
                const framesWithTooltip = `
                    <span style="position: relative; cursor: help; border-bottom: 1px dotted currentColor;" 
                          class="fg-frames-tooltip-trigger">
                        ${framesText}
                        <span class="fg-frames-tooltip" style="
                            position: absolute;
                            top: calc(100% + 8px);
                            left: 50%;
                            transform: translateX(-50%);
                            background: #333;
                            color: white;
                            padding: 8px 12px;
                            border-radius: 6px;
                            font-size: 0.8rem;
                            white-space: normal;
                            width: 200px;
                            opacity: 0;
                            pointer-events: none;
                            transition: opacity 0.2s;
                            z-index: 1000;
                            line-height: 1.4;
                            text-transform: none;
                        ">${tooltipText}</span>
                    </span>
                `;
                metaParts.push(framesWithTooltip);
            } else {
                metaParts.push(framesText);
            }
        }

        // Service Type - moved to separate tags line
        if (data.service_type) {
            tagParts.push(data.service_type === 'CUSTOM' ? 'SAMMLUNG' : data.service_type);
        }

        // Visibility Tag - moved to separate tags line
        if (data.visibility) {
            let visibilityLabel = '';
            if (data.visibility === 'PRIVATE') {
                visibilityLabel = 'PRIVAT';
            } else if (data.visibility === 'PUBLIC') {
                visibilityLabel = 'ÖFFENTLICH';
            } else if (data.visibility === 'PUBLIC_WITH_LOGIN') {
                visibilityLabel = 'ÖFFENTLICH MIT LOGIN';
            }
            if (visibilityLabel) {
                tagParts.push(visibilityLabel);
            }
        }

        // Desktop & Mobile: All info in one line, joined by bullets
        // Each part is wrapped in a nowrap span so they break only at separators
        const wrappedMeta = metaParts.map(part => `<span style="white-space: nowrap;">${part}</span>`);
        const wrappedTags = tagParts.map(tag => `<span style="white-space: nowrap;">${tag}</span>`);
        const allWrappedParts = [...wrappedMeta, ...wrappedTags];

        metaHtml = `
            <div class="fg-meta-relative-wrapper">
                <div class="fg-meta-text">${allWrappedParts.join(' &nbsp;&bull;&nbsp; ')}</div>
            </div>
        `;

        // Verify HTML content
        console.log('Generated Meta HTML:', metaHtml);

        // Define Selector FIRST
        const $metaGrid = $('.fg-metadata-grid');
        console.log('DOM Target .fg-metadata-grid found:', $metaGrid.length);

        $metaGrid.html(metaHtml).addClass('fg-meta-row-clean');
        $('.fg-date').remove();

        // Cover Image (optional, if we want to use it somewhere)
        if (data.cover_url) {
            // console.log('Cover URL:', data.cover_url);
        }

        // Handle Ownership (Assignment Banner)
        checkOwnership(data);

        // Handle Issues (Film Doctor)
        handleFilmDoctor(data);

        // Update Edit Controls Visibility based on Ownership
        updateEditControlsVisibility();
    }

    // --- EDIT CONTROLS VISIBILITY ---
    function updateEditControlsVisibility() {
        // Only owners can edit name, date, and visibility
        if (isFilmOwner) {
            $('.edit-name-btn').show();
            $('.edit-date-btn').show();
            $('.edit-visibility-btn').show();
            $('.delete-film-btn').text(isCollection ? 'Sammlung löschen' : 'Film löschen').show();
        } else {
            $('.edit-name-btn').hide();
            $('.edit-date-btn').hide();
            $('.edit-visibility-btn').hide();
            $('.delete-film-btn').hide();
        }
    }


    // --- ASSIGNMENT LOGIC ---
    function checkOwnership(data) {
        // Clear existing elements
        $('.fg-assign-banner').remove();
        $('.fg-linked-badge').remove();
        $('.fg-ownership-indicator').remove();

        const customerId = window.FilmGalleryConfig.customerId;

        // NEW: Guest bei Unclaimed Film (PUBLIC visibility)
        if (!customerId && !data.has_owner) {
            showGuestClaimHint();
            return;
        }

        // Rest of logic only for logged-in users
        if (!customerId) return;

        // NEW LOGIC: Boolean Flags from Backend
        // has_owner: true if ANY owner exists
        // is_owner: true if CURRENT USER is valid owner
        // has_relation: true if CURRENT USER has a link (owner or bookmark)

        // Reset global owner flag
        isFilmOwner = false;

        const hasOwner = data.has_owner === true;
        const isOwner = data.is_owner === true;
        const hasRelation = data.has_relation === true;

        console.log('Ownership Check:', { hasOwner, isOwner, hasRelation });

        if (!hasOwner) {
            // CASE: UNCLAIMED
            // No owner exists -> Show Claim Banner
            showBanner(
                'claim',
                'Film-QR-Label einlösen und zu meinem Account hinzufügen',
                'Registriere dieses Film-QR-Label, um Updates zur Entwicklung zu erhalten und deine Bilder später anzusehen.',
                'Film hinzufügen',
                ($btn) => claimFilm(customerId, labServiceId, $btn)
            );

        } else if (isOwner) {
            // CASE: OWNED_BY_CURRENT_USER
            // User is the owner -> Full Control
            isFilmOwner = true;
            showOwnershipIndicator(true); // Green dot for owner status

        } else {
            // CASE: OWNED_BY_OTHER
            // Someone else owns it. Do we have a link?

            if (hasRelation) {
                // CASE: LINKED_TO_CURRENT_USER
                // User has bookmarked it -> Show Link Indicator
                showOwnershipIndicator(false); // Blue dot for linked status
            } else {
                // CASE: NOT LINKED
                // User has no relation -> Show Bookmark Banner
                showBanner(
                    'link',
                    'Zu meinen Filmen hinzufügen',
                    'Möchtest du diesen Film in deiner Sammlung speichern? So findest du ihn jederzeit wieder.',
                    'Film hinzufügen',
                    ($btn) => linkFilm(customerId, labServiceId, $btn)
                );
            }
        }
    }

    // --- HELPER FUNCTIONS FOR UI ---

    function showBanner(type, title, text, buttonText, onClickHandler) {
        const bgClass = type === 'claim' ? 'fg-claim-banner' : 'fg-link-banner';

        const html = `
            <div class="fg-assign-banner ${bgClass}">
                <h3>${title}</h3>
                <p>${text}</p>
                <button class="button button--primary" is="hover-button">
                    <span class="btn-fill" data-fill></span>
                    <span class="btn-text">${buttonText}</span>
                </button>
            </div>
        `;

        const $banner = $(html);
        $('.fg-info').append($banner);

        // Attach Handler
        $banner.find('button').on('click', function () {
            onClickHandler($(this));
        });
    }

    function showOwnershipIndicator(isOwner) {
        // Remove any existing indicator
        $('.fg-ownership-indicator').remove();

        // Determine color and text based on ownership
        const color = isOwner ? '#80d886ff' : '#89c5f7ff'; // Green for owner, Pastel Blue for linked
        const tooltipText = isOwner
            ? (isCollection ? 'Du bist Besitzer dieser Sammlung' : 'Du bist Besitzer dieses Films')
            : 'In deiner Sammlung gespeichert';

        // Create indicator dot with tooltip
        const html = `
            <span class="fg-ownership-indicator" style="
                display: inline-flex;
                align-items: center;
                margin-left: 8px;
                position: relative;
                cursor: help;
                vertical-align: middle;
                transform: translateY(-2px);
            ">
                <span class="fg-ownership-dot" style="
                    width: 10px;
                    height: 10px;
                    background: ${color};
                    border-radius: 50%;
                    display: inline-block;
                    box-shadow: 0 0 0 2px ${color}40;
                "></span>
                <span class="fg-ownership-tooltip" style="
                    position: absolute;
                    bottom: calc(100% + 8px);
                    left: 50%;
                    transform: translateX(-50%);
                    background: #333;
                    color: white;
                    padding: 6px 12px;
                    border-radius: 6px;
                    font-size: 0.85rem;
                    white-space: nowrap;
                    opacity: 0;
                    pointer-events: none;
                    transition: opacity 0.2s;
                    z-index: 1000;
                ">${tooltipText}</span>
            </span>
        `;

        // Insert next to title
        $('.fg-title').append(html);

        // Desktop: Hover to show tooltip
        $('.fg-ownership-indicator').on('mouseenter', function () {
            $(this).find('.fg-ownership-tooltip').css('opacity', '1');
        }).on('mouseleave', function () {
            $(this).find('.fg-ownership-tooltip').css('opacity', '0');
        });

        // Mobile: Tap to toggle tooltip
        let tooltipVisible = false;
        $('.fg-ownership-indicator').on('click touchstart', function (e) {
            e.preventDefault();
            e.stopPropagation();
            tooltipVisible = !tooltipVisible;
            $(this).find('.fg-ownership-tooltip').css('opacity', tooltipVisible ? '1' : '0');
        });

        // Hide tooltip when clicking elsewhere on mobile
        $(document).on('click touchstart', function (e) {
            if (!$(e.target).closest('.fg-ownership-indicator').length) {
                $('.fg-ownership-tooltip').css('opacity', '0');
                tooltipVisible = false;
            }
        });
    }

    // --- ACTIONS ---

    async function claimFilm(customerId, labServiceId, $btn) {
        $btn.prop('disabled', true).text('Wird beansprucht...');

        try {
            // API: PUT /labservice/relation/<customer_id>/<labservice_id>
            // This endpoint sets owner if no owner exists, otherwise creates a relation
            const response = await fetch(`https://backend.wiederfaenger.ch/labservice/relation/${customerId}/${labServiceId}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' }
            });

            if (response.ok) {
                // Success
                $btn.parent().addClass('success').html(`
                    <h3>Erfolgreich hinzugefügt!</h3>
                    <p>Dieser Lab Service gehört nun dir.</p>
                `);
                // Reload or hide
                setTimeout(function () {
                    location.reload(); // Reload to get fresh state (OWNED_BY_CURRENT_USER)
                }, 2000);
            } else {
                throw new Error('Claim failed');
            }
        } catch (err) {
            console.error('Claim Error:', err);
            $btn.prop('disabled', false).text('Fehler - Nochmal versuchen');
            alert('Fehler beim Beanspruchen. Bitte Support kontaktieren.');
        }
    }

    async function linkFilm(customerId, labServiceId, $btn) {
        $btn.prop('disabled', true).text('Wird hinzugefügt...');

        try {
            // API: PUT /labservice/relation/<customer_id>/<labservice_id>
            const response = await fetch(`https://backend.wiederfaenger.ch/labservice/relation/${customerId}/${labServiceId}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' }
            });

            if (response.ok) {
                // Success UI
                $btn.parent().addClass('success').html(`
                    <h3>Erfolgreich hinzugefügt!</h3>
                    <p>Dieser Film ist nun in deiner Sammlung gespeichert.</p>
                `);
                setTimeout(function () {
                    location.reload(); // Reload to get fresh state (LINKED_TO_CURRENT_USER)
                }, 2000);
            } else {
                throw new Error('Link failed');
            }
        } catch (err) {
            console.error('Assignment Error:', err);
            $btn.prop('disabled', false).text('Fehler - Nochmal versuchen');
            alert('Fehler beim Zuordnen. Bitte versuche es später noch einmal.');
        }
    }
    // End new assignment logic

    function handleStatus(data) {
        let status = data.status;

        // CRITICAL: Backward Compatibility
        // ALWAYS prioritize actual image presence over status field
        // This ensures old lab services without proper status field still work
        const hasImages = data.images && data.images.length > 0;

        if (hasImages) {
            // If images exist, ALWAYS show them regardless of status
            status = 'UPLOADED';
        } else if (status === null || status === undefined) {
            // If no images AND no status field, assume PENDING
            status = 'PENDING';
        } else if (!status) {
            // Fallback for empty string or other falsy values
            status = 'PENDING';
        }

        $statusContainer.empty();

        if (status === 'PENDING') {
            $grid.hide();
            $doctorContainer.addClass('fg-hidden');

            let title = 'Diese Galerie wartet auf deinen Film';
            let desc = 'Dein Film ist noch unterwegs zu uns ins Labor oder du bist noch fleissig am Fotografieren. Sobald er entwickelt und gescannt ist, informieren wir dich.';

            if (isCollection) {
                title = 'Diese Sammlung ist leer';
                desc = 'Du hast noch keine Bilder zu dieser Sammlung hinzugefügt oder sie wurde möglicherweise gelöscht.';
            } else if (!isFilmOwner) {
                title = 'Galerie wartet auf Bilder';
                desc = 'Sobald der Film entwickelt und gescannt ist, erscheinen hier die Bilder.';
            }

            $statusContainer.removeClass('fg-hidden').html(`
                <div class="fg-status-card">
                    <div class="fg-status-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                    </div>
                    <h3 class="fg-status-title">${title}</h3>
                    <p>${desc}</p>
                </div>
            `);
        } else if (status === 'RECEIVED') {
            $grid.hide();
            $doctorContainer.addClass('fg-hidden');

            let title = 'Im Labor angekommen!';
            let desc = 'Dein Film ist gut bei uns angekommen! Wir sind gerade dabei ihn zu entwickeln und zu scannen.';

            if (!isFilmOwner) {
                desc = 'Der Film ist eingetroffen und wird gerade entwickelt und gescannt.';
            }

            $statusContainer.removeClass('fg-hidden').html(`
                <div class="fg-status-card">
                    <div class="fg-status-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                    </div>
                    <h3 class="fg-status-title">${title}</h3>
                    <p>${desc}</p>
                </div>
            `);
        } else {
            // UPLOADED (or forced UPLOADED because images exist)

            if (!hasImages) {
                // CASE: UPLOADED but NO IMAGES (Blank Roll / Issues)
                $grid.hide();
                $doctorContainer.addClass('fg-hidden');

                const title = 'Keine Bilder vorhanden';
                const desc = 'Wir haben deinen Film entwickelt, konnten aber leider keine Bilder darauf finden. Dies passiert oft, wenn der Film nicht belichtet wurde.';

                $statusContainer.removeClass('fg-hidden').html(`
                    <div class="fg-status-card">
                        <div class="fg-status-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                                <path d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <h3 class="fg-status-title">${title}</h3>
                        <p>${desc}</p>
                         <a href="https://wiederfaenger.ch/blogs/filmdoktor" target="_blank" class="button button--primary" is="hover-link">
                            <span class="btn-fill" data-fill></span>
                            <span class="btn-text">Ursachen ansehen</span>
                         </a>
                    </div>
                `);
                initHoverButtons($statusContainer);

            } else {
                // Normal Case: Images Exist
                $grid.show();
                // Doctor visibility handled separately
                $statusContainer.addClass('fg-hidden');
            }
        }
    }

    async function handleFilmDoctor(data) {
        const issues = data.issues || [];
        if (issues.length === 0) return;

        try {
            const [issueMapping, issuesV2] = await Promise.all([fetchIssueCodeMapping(), fetchFilmIssuesV2()]);
            const $list = $('#film-doctor-issues-list');
            $list.empty();
            let hasVisible = false;

            let validIssueCount = 0;

            issues.forEach(issue => {
                // API now only provides intake_code (numeric)
                // We need to map it to the code name using the mapping
                let codeName = null;

                if (issue.intake_code) {
                    codeName = issueMapping[issue.intake_code];
                }

                // Fallback to direct code if provided (legacy support)
                if (!codeName && issue.code) {
                    codeName = issue.code;
                }

                const info = codeName && (FILM_ISSUES[codeName] || (issuesV2[codeName] && issueInfoV2(issuesV2[codeName], issue)));
                if (info) {

                    // Determine severity color
                    const severityColors = {
                        '🔴': '#ef4444', // Red - Critical
                        '🟠': '#f97316', // Orange - Medium
                        '🟡': '#eab308', // Yellow - Info
                        '🔵': '#3b82f6'  // Blue - Hint
                    };
                    const severityColor = severityColors[info.severity] || '#f97316';

                    // Build causes list HTML
                    let causesHtml = '';
                    if (info.causes && info.causes.length > 0) {
                        causesHtml = `
                            <div class="film-doctor-section">
                                <strong>Mögliche Ursachen:</strong>
                                <ul>
                                    ${info.causes.map(cause => `<li>${cause}</li>`).join('')}
                                </ul>
                            </div>
                        `;
                    }

                    // Build prevention HTML
                    let preventionHtml = '';
                    if (info.prevention) {
                        let content = '';
                        if (Array.isArray(info.prevention)) {
                            content = `<ul>${info.prevention.map(p => `<li>${p}</li>`).join('')}</ul>`;
                        } else {
                            content = `<ul><li>${info.prevention}</li></ul>`;
                        }

                        preventionHtml = `
                            <div class="film-doctor-section">
                                <strong>So vermeidest du das:</strong>
                                ${content}
                            </div>
                        `;
                    }

                    // Build help link HTML
                    let helpHtml = '';
                    if (info.helpUrl) {
                        helpHtml = `
                            <div class="film-doctor-help">
                                <a href="${info.helpUrl}" target="_blank" rel="noopener">
                                    Hilfe & Support →
                                </a>
                            </div>
                        `;
                    }

                    $list.append(`
                        <div class="film-doctor-item">
                            <div class="film-doctor-header-row">
                                <div class="film-doctor-icon" style="color: ${severityColor};">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                                        <line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line>
                                    </svg>
                                </div>
                                <div class="film-doctor-text">
                                    <h4>${info.title}</h4>
                                    <p class="film-doctor-description">${info.description}</p>
                                </div>
                            </div>
                            
                            <div class="film-doctor-details-grid">
                                ${causesHtml}
                                ${preventionHtml}
                            </div>
                            
                            ${helpHtml}
                        </div>
                    `);
                    hasVisible = true;
                    validIssueCount++;
                }
            });

            if (hasVisible) {
                // Populate Issue Count Badge
                $('#film-doctor-count').text(validIssueCount).removeClass('fg-hidden');

                $doctorContainer.removeClass('fg-hidden');
                // Toggle Logic handled in snippet script or here?
                // Assuming snippet logic needs binding here:
                $('.film-doctor-header').off('click').on('click', function () {
                    $doctorContainer.toggleClass('open');
                });
            } else {
                $('#film-doctor-count').addClass('fg-hidden');
            }
        } catch (e) {
            console.error('Film Doctor Error', e);
        }
    }


    // Masonry State
    let columnCount = 2; // Default
    let columns = [];

    // Initialize Columns
    function initMasonryGrid() {
        const width = $(window).width();
        if (width >= 1200) columnCount = 4;
        else if (width >= 768) columnCount = 3;
        else columnCount = 2;

        $grid.html(''); // Clear grid
        columns = [];

        for (let i = 0; i < columnCount; i++) {
            const col = $(`<div class="fg-column"></div>`);
            $grid.append(col);
            columns.push(col);
        }
    }

    // Debounced Resize
    let resizeTimer;
    $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            // Re-init only if column count changes? 
            // For simplicity and correctness, re-render
            const width = $(window).width();
            let newCols = 2;
            if (width >= 1200) newCols = 4;
            else if (width >= 768) newCols = 3;

            if (newCols !== columnCount) {
                // Re-render all existing images
                initMasonryGrid();
                renderImages(allImages);
            }
        }, 300);
    });


    // Initial Init
    initMasonryGrid();

    // Helper to extract UUID from Linode/AWS URL
    // URL: https://.../019b3c43-f200-75da-b3eb-7ecb24fd3fb9
    // Returns: 019b3c43-f200-75da-b3eb-7ecb24fd3fb9
    function extractIdFromUrl(url) {
        if (!url) return null;
        try {
            const parts = url.split('/');
            const filename = parts[parts.length - 1]; // "uuid" or "uuid.jpg"
            // If it has query params, strip them
            const cleanFilename = filename.split('?')[0];
            // If strictly UUID without extension is needed?
            // The user logs showed url ending in UUID directly.
            // But assume it might have extension? User example: .../019b3c43-f200-75da-b3eb-7ecb24fd3fb9 (no extension)
            return cleanFilename;
        } catch (e) {
            console.error('ID Extraction failed', e);
            return null;
        }
    }

    async function renderImages(images) {
        if (!images || images.length === 0) return;

        // Ensure Layout context
        if (columns.length === 0) initMasonryGrid();

        // 1. Preload Items for Dimensions (Smart Masonry)
        const loadedItems = await Promise.all(images.map(imgData => new Promise(resolve => {
            // WORKAROUND: Extract ID from URL if missing from API
            if (!imgData.id) {
                imgData.id = extractIdFromUrl(imgData.image_url);
            }
            if (!imgData.id) console.warn('Still no ID after extraction:', imgData);

            const img = new Image();
            img.src = imgData.image_preview_url;
            img.onload = () => resolve({ ...imgData, naturalWidth: img.width, naturalHeight: img.height, success: true });
            img.onerror = () => resolve({ ...imgData, naturalWidth: 100, naturalHeight: 100, success: false });
        })));

        // 2. Distribute based on Shortest Column
        const currentHeights = columns.map(c => c.height());
        const colWidth = columns[0].width() || ($(window).width() / columnCount);

        loadedItems.forEach(itemData => {
            // Find Shortest Column
            const minH = Math.min(...currentHeights);
            const colIndex = currentHeights.indexOf(minH);

            // Create DOM Element
            const link = createGalleryItem(itemData);

            // Append to DOM
            columns[colIndex].append(link);

            // Update Virtual Height
            const aspectRatio = itemData.naturalWidth / itemData.naturalHeight;
            const virtualHeight = colWidth / aspectRatio;
            currentHeights[colIndex] += virtualHeight;

            // Trigger Fade In
            link.addClass('loaded');
            if (link.find('img')[0].complete) {
                link.find('img').addClass('loaded');
            } else {
                link.find('img').on('load', function () { $(this).addClass('loaded'); });
            }
        });
    }

    function createGalleryItem(imgData) {


        // Link (Trigger)
        const link = $('<a>')
            .attr('data-fancybox', 'gallery')
            .attr('href', imgData.image_url)
            // Pass as option so it appears in instance.current.opts
            .attr('data-options', `{ "imageId": "${imgData.id}" } `)
            // IMPORTANT: Add Explicit ID for DOM selection (deletion)
            .attr('data-image-id', imgData.id)
            .addClass('fg-grid-item');

        // Image
        const img = $('<img>')
            .attr('src', imgData.image_preview_url)
            .attr('loading', 'lazy')
            .on('load', function () {
                $(this).closest('.fg-grid-item').addClass('loaded');
            });
        // Safety check
        if (img[0].complete) link.addClass('loaded');

        link.append(img);

        // Unique ID on ANCHOR (Stable Container)
        const globalIndex = allImages.findIndex(i => i.image_url === imgData.image_url);
        const itemId = `fg-item-${globalIndex}`;
        link.attr('id', itemId);

        // Click Handler for Custom Fancybox Order
        link.on('click', (e) => {
            e.preventDefault();

            // Debug: Check Data Structure
            if (allImages.length > 0) {
                console.log('First Image in Memory:', allImages[0]);
                console.log('Clicked Image Data:', imgData);
            }

            // Prepare items from sorted allImages source of truth
            const galleryItems = allImages.map((imgEntry, idx) => {
                // Ensure ID is present in map too
                const entryId = imgEntry.id || extractIdFromUrl(imgEntry.image_url);

                return {
                    src: imgEntry.image_url,
                    type: 'image',
                    // Attempt to attach ID to object root as well
                    id: entryId,
                    opts: {
                        thumb: imgEntry.image_preview_url,
                        // Match ID on Anchor (Stable Block Element)
                        $orig: $(`#fg-item-${idx}`),
                        imageId: entryId,
                        zoomEffect: true
                    }
                };
            });

            // Find index of clicked image
            const currentIndex = allImages.findIndex(i => i.image_url === imgData.image_url);

            // Debug to ensure found
            // console.log('Zoom Origin:', $(`#fg - item - ${ currentIndex } `));

            // Define Buttons based on Ownership
            const actionButtons = [];
            if (isFilmOwner) {
                actionButtons.push('delete', 'cover');
            }
            actionButtons.push('collection', 'favorite', 'download', 'cart');
            const fancyboxButtons = ['back', ...actionButtons];

            $.fancybox.open(galleryItems, {
                index: currentIndex,
                // Load custom button set
                buttons: fancyboxButtons,
                loop: false,
                baseClass: 'fg-fancybox-white',

                // Localization (German)
                i18n: {
                    en: {
                        CLOSE: "Schliessen",
                        NEXT: "Nächstes Bild",
                        PREV: "Vorheriges Bild",
                        ERROR: "Der angeforderte Inhalt kann nicht geladen werden. <br/> Bitte versuchen Sie es später noch einmal.",
                        PLAY_START: "Diashow starten",
                        PLAY_STOP: "Diashow anhalten",
                        FULL_SCREEN: "Vollbild",
                        THUMBS: "Vorschaubilder",
                        DOWNLOAD: "Herunterladen",
                        SHARE: "Teilen",
                        ZOOM: "Vergrössern"
                    }
                },

                // Custom Button Templates (SVGs)
                btnTpl: {
                    back: '<button data-fancybox-close class="fancybox-button fancybox-button--back" title="Zurück zur Galerie">' +
                        '<svg viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>' +
                        '</button>',

                    cart: '<button data-fancybox-cart class="fancybox-button fancybox-button--cart-text" style="background: #000000 !important; color: #ffffff !important; border-radius: 0 !important; width: auto; height: 28px !important; margin: auto 8px auto 0; font-family: var(--fg-font-family); font-size: 12px; font-weight: 500; border: none; cursor: pointer; padding: 0 12px; display: flex; align-items: center; justify-content: center;">Abzug bestellen</button>',

                    download: '<a download data-fancybox-download class="fancybox-button fancybox-button--download" title="Herunterladen">' +
                        '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                        '<path d="M7.70711 10.2929L11 13.5858L11 3C11 2.44771 11.4477 2 12 2C12.5523 2 13 2.44771 13 3L13 13.5858L16.2929 10.2929C16.6834 9.90237 17.3166 9.90237 17.7071 10.2929C18.0976 10.6834 18.0976 11.3166 17.7071 11.7071L12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071L6.29289 11.7071C5.90237 11.3166 5.90237 10.6834 6.29289 10.2929C6.68342 9.90237 7.31658 9.90237 7.70711 10.2929Z" fill="currentColor"/>' +
                        '<path d="M4 22C3.44772 22 3 21.5523 3 21C3 20.4477 3.44772 20 4 20H20C20.5523 20 21 20.4477 21 21C21 21.5523 20.5523 22 20 22H4Z" fill="currentColor"/>' +
                        '</svg></a>',

                    cover: '<button data-fancybox-cover class="fancybox-button fancybox-button--cover" title="Als Coverbild setzen">' +
                        '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                        '<path d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z" fill="currentColor"/>' +
                        '<path fill-rule="evenodd" clip-rule="evenodd" d="M2 5C2 3.34315 3.34315 2 5 2H19C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5ZM5 4C4.44772 4 4 4.44772 4 5V17.5857L9.29285 12.2928C9.68337 11.9023 10.3165 11.9023 10.7071 12.2928L12.5 14.0857L20 6.58569V5C20 4.44772 19.5523 4 19 4H5ZM20 9.41412L13.2071 16.2071C12.8165 16.5976 12.1834 16.5976 11.7928 16.2071L9.99995 14.4142L4.5308 19.8833C4.67072 19.9578 4.83043 20 5 20H19C19.5523 20 20 19.5523 20 19V9.41412Z" fill="currentColor"/>' +
                        '</svg></button>',

                    delete: `<button data-fancybox-delete class="fancybox-button fancybox-button--delete" title="${isCollection ? 'Aus Sammlung entfernen' : 'Löschen'}">` +
                        '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                        '<path fill-rule="evenodd" clip-rule="evenodd" d="M7 4C7 2.34315 8.34315 1 10 1H14C15.6569 1 17 2.34315 17 4V5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H19.9394L19.1153 20.1871C19.0164 21.7682 17.7053 23 16.1211 23H7.8789C6.29471 23 4.98356 21.7682 4.88474 20.1871L4.06055 7H3C2.44772 7 2 6.55228 2 6C2 5.44772 2.44772 5 3 5H7V4ZM9 5H15V4C15 3.44772 14.5523 3 14 3H10C9.44772 3 9 3.44772 9 4V5ZM6.06445 7L6.88085 20.0624C6.91379 20.5894 7.35084 21 7.8789 21H16.1211C16.6492 21 17.0862 20.5894 17.1191 20.0624L17.9355 7H6.06445Z" fill="currentColor"/>' +
                        '</svg></button>',

                    favorite: '<button data-fancybox-favorite class="fancybox-button fancybox-button--favorite" title="Zu Favoriten hinzufügen">' +
                        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-heart-icon lucide-heart" style="width: 100%; height: 100%;"><path d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"/></svg></button>',

                    collection: '<button data-fancybox-collection class="fancybox-button fancybox-button--collection" title="Zu Sammlung hinzufügen">' +
                        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-folder-icon lucide-folder" style="width: 100%; height: 100%;"><path d="M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"/></svg></button>'
                },

                // Transition Logic
                idleTime: false,
                backdropOpacity: 1,

                // Open/Close Animation (Zoom)
                animationEffect: "zoom",
                animationDuration: 400,

                // Hide Shopify Chat when Lightbox is open (with Fade)
                beforeShow: function () {
                    $('shopify-chat, shopify-agent, inbox-online-store-chat, #dummy-chat-button-iframe, iframe#shopify-chat, #shopify-chat, #ShopifyChat, iframe[id^="dummy-chat-button"], .chat-toggle, [data-spec="toggle-button"]').fadeOut(400);
                },
                afterClose: function () {
                    $('shopify-chat, shopify-agent, inbox-online-store-chat, #dummy-chat-button-iframe, iframe#shopify-chat, #shopify-chat, #ShopifyChat, iframe[id^="dummy-chat-button"], .chat-toggle, [data-spec="toggle-button"]').fadeIn(400);
                },
                zoomOpacity: "auto",

                // Navigation Animation
                transitionEffect: false,
                transitionDuration: 0,

                // Event Handlers for Custom Buttons
                onInit: function (instance) {
                    // Attach listeners to toolbar
                    const $toolbar = instance.$refs.toolbar;

                    // Add Wiederfaenger Logo
                    const logoUrl = window.FilmGalleryConfig?.logoUrl;
                    if (logoUrl && logoUrl !== '') {
                        $(instance.$refs.container).append(`
                            <img class="fg-lightbox-logo" src="${logoUrl}" alt="Wiederfaenger">
                        `);
                    }

                    // Cart
                    $toolbar.on('click', '[data-fancybox-cart]', function () {
                        const current = instance.current;
                        addPhotoToCart(current.src, instance); // Pass instance to close on success
                        $(this).addClass('added'); // Visual feedback
                        // Optional: Show checkmark?
                    });

                    // Collection
                    $toolbar.on('click', '[data-fancybox-collection]', function () {
                        const current = instance.current;
                        let imageId = current.opts.imageId
                            || $(current.triggerEl).data('image-id')
                            || (current.opts.$orig ? $(current.opts.$orig).data('image-id') : null);

                        if (!imageId && current.src) {
                            const foundImg = allImages.find(img => img.image_url === current.src);
                            if (foundImg) {
                                imageId = foundImg.id || foundImg._id || foundImg.image_id;
                            }
                        }
                        if (!imageId && current.src) {
                            imageId = current.src.split('/').pop().split('?')[0];
                        }

                        window.openAddToCollectionModal({
                            id: imageId,
                            image_url: current.src
                        });
                    });

                    // Favorite
                    $toolbar.on('click', '[data-fancybox-favorite]', async function () {
                        if (!window.FilmGalleryConfig.customerId) {
                            alert('Bitte melde dich an, um Favoriten zu nutzen.');
                            return;
                        }
                        const current = instance.current;
                        let imageId = current.opts.imageId
                            || $(current.triggerEl).data('image-id')
                            || (current.opts.$orig ? $(current.opts.$orig).data('image-id') : null);

                        if (!imageId && current.src) {
                            const foundImg = allImages.find(img => img.image_url === current.src);
                            if (foundImg) {
                                imageId = foundImg.id || foundImg._id || foundImg.image_id;
                            }
                        }
                        if (!imageId && current.src) {
                            imageId = current.src.split('/').pop().split('?')[0];
                        }

                        const $btn = $(this);
                        const originalSvg = $btn.html();
                        $btn.html('<span style="font-size:12px; color:currentColor; font-weight:bold; display:flex; align-items:center; justify-content:center; width:100%; height:100%;">...</span>');

                        try {
                            const res = await fetch(`https://backend.wiederfaenger.ch/mylabservices/${window.FilmGalleryConfig.customerId}`);
                            const data = await res.json();
                            let favoriteCol = data.find(c => c.name.toLowerCase() === 'favoriten' && (c.collection_kind === 'CUSTOM' || c.service_type === 'CUSTOM'));
                            
                            let collectionId = favoriteCol ? favoriteCol.labservice_id : null;
                            let isNew = false;

                            if (!collectionId) {
                                const createRes = await fetch(`https://backend.wiederfaenger.ch/collection`, {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/json' },
                                    body: JSON.stringify({ customer_id: window.FilmGalleryConfig.customerId, name: 'Favoriten' })
                                });
                                if (!createRes.ok) throw new Error('Create failed');
                                const colIdStr = await createRes.text();
                                collectionId = colIdStr.replace(/['"]+/g, '');
                                isNew = true;
                            }

                            const addRes = await fetch(`https://backend.wiederfaenger.ch/collection/${window.FilmGalleryConfig.customerId}/${collectionId}/image/${imageId}`, { method: 'PUT' });
                            if (!addRes.ok) throw new Error('Add failed');

                            if (isNew) {
                                await fetch(`https://backend.wiederfaenger.ch/labservicecover/${collectionId}/${imageId}`, { method: 'PUT' });
                                await fetch(`https://backend.wiederfaenger.ch/labservice/visibility/${window.FilmGalleryConfig.customerId}/${collectionId}/PRIVATE`, { method: 'PUT' });
                            }

                            $btn.html(originalSvg);
                            
                            const collectionUrl = `${window.FilmGalleryConfig.routes.root_url}pages/dein-film?An6Sr6ze6jNg=${collectionId}`;
                            $('#fg-favorite-success-modal a.favoriten-link').attr('href', collectionUrl);
                            $('#fg-favorite-success-modal').removeClass('fg-hidden');
                            
                            setTimeout(() => {
                                $('#fg-favorite-success-modal').addClass('fg-hidden');
                            }, 4000);
                        } catch (e) {
                            console.error(e);
                            alert('Fehler beim Hinzufügen zu Favoriten.');
                            $btn.html(originalSvg);
                        }
                    });

                    // Cover
                    $toolbar.on('click', '[data-fancybox-cover]', function () {
                        if (!confirm('Dieses Bild als Coverbild setzen?')) return;

                        const current = instance.current;

                        // Robust ID Retrieval
                        // 1. Try opts.imageId
                        // 2. Try triggerEl data attr
                        // 3. Try opts.$orig data attr
                        // 4. FALLBACK: Lookup by SRC in global allImages (Bypass Fancybox completely)

                        let imageId = current.opts.imageId
                            || $(current.triggerEl).data('image-id')
                            || (current.opts.$orig ? $(current.opts.$orig).data('image-id') : null);

                        if (!imageId && current.src) {
                            console.warn('ID missing in opts. Trying fallback lookup by SRC...');
                            const foundImg = allImages.find(img => img.image_url === current.src);
                            if (foundImg) {
                                console.log('Found image by SRC:', foundImg);
                                imageId = foundImg.id || foundImg._id || foundImg.image_id; // Try potential key permutations
                            } else {
                                console.error('Could not find image in global array with src:', current.src);
                                // Debug: Dump keys of first image to see what ID is called
                                if (allImages.length > 0) {
                                    console.log('First Image Keys:', Object.keys(allImages[0]));
                                }
                            }
                        }

                        console.log('--- Cover Start ---');
                        console.log('Current Obj:', current);
                        console.log('Detected ID:', imageId);

                        if (!imageId) {
                            console.warn('Failed to retrieve Image ID. Check console for "Current Obj" and "First Image Keys".');
                        }
                        setCoverImage(imageId);
                    });

                    // Delete
                    $toolbar.on('click', '[data-fancybox-delete]', function () {
                        const confirmMsg = isCollection
                            ? 'Bild aus der Sammlung entfernen? Das Bild bleibt in deinem Film erhalten.'
                            : 'Bild wirklich löschen? Dies kann nicht rückgängig gemacht werden.';
                        if (!confirm(confirmMsg)) return;

                        const current = instance.current;
                        let imageId = current.opts.imageId
                            || $(current.triggerEl).data('image-id')
                            || (current.opts.$orig ? $(current.opts.$orig).data('image-id') : null);

                        // Fallback Lookup
                        if (!imageId && current.src) {
                            const foundImg = allImages.find(img => img.image_url === current.src);
                            if (foundImg) {
                                imageId = foundImg.id || foundImg._id || foundImg.image_id;
                            }
                        }

                        console.log('--- Delete Start ---');
                        console.log('Detected ID:', imageId);

                        if (isCollection) {
                            alert('Funktion bald verfügbar.');
                        } else {
                            deleteImage(imageId, instance);
                        }
                    });

                    // Download - Intercept for Mobile & Desktop
                    $(document).off('click', '[data-fancybox-download]').on('click', '[data-fancybox-download]', async function (e) {
                        e.preventDefault();
                        e.stopPropagation();

                        const current = instance.current;
                        if (!current) return;

                        if (isMobile()) {
                            showMobileDownloadOverlay(current.src);
                        } else {
                            // Desktop: Fetch and download with custom filename
                            try {
                                const response = await fetch(current.src, { mode: 'cors', cache: 'no-store' });
                                const blob = await response.blob();

                                // Generate filename with metadata
                                const sanitize = (str) => (str || '').trim().replace(/[^a-z0-9]/gi, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
                                const meta = window.galleryMetadata || {};
                                const filmName = sanitize(meta.title || 'Film');
                                const dateStr = meta.filenameDate || new Date().toISOString().split('T')[0];
                                const shotNr = String((current.index || 0) + 1).padStart(3, '0');

                                const filename = `Wiederfaenger-${filmName}-Bild${shotNr}-${dateStr}.jpg`;

                                // Create download
                                const blobUrl = window.URL.createObjectURL(blob);
                                const link = document.createElement('a');
                                link.href = blobUrl;
                                link.download = filename;
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                                window.URL.revokeObjectURL(blobUrl);

                            } catch (error) {
                                console.error('Download failed:', error);
                                // Fallback: open in new tab
                                window.open(current.src, '_blank');
                            }
                        }
                    });
                    // Long Press Interceptor (Mobile) - Manual Touch Timer
                    if (isMobile()) {
                        let pressTimer;
                        let startX, startY;
                        const PRESS_DURATION = 800; // ms

                        const container = $(instance.$refs.container);

                        // Helper: Trigger our custom overlay
                        const triggerCustomAction = () => {
                            const current = instance.current;
                            // Visual Feedback (Vibration if supported)
                            if (navigator.vibrate) navigator.vibrate(50);
                            showMobileDownloadOverlay(current.src);
                        };

                        container.on('touchstart', 'img', function (e) {
                            // Cancel if multi-touch (pinch-to-zoom)
                            if (e.originalEvent.touches.length > 1) {
                                clearTimeout(pressTimer);
                                return;
                            }

                            startX = e.originalEvent.touches[0].clientX;
                            startY = e.originalEvent.touches[0].clientY;

                            pressTimer = setTimeout(() => {
                                triggerCustomAction();
                            }, PRESS_DURATION);
                        });

                        container.on('touchmove', 'img', function (e) {
                            // Cancel if multi-touch (pinch-to-zoom)
                            if (e.originalEvent.touches.length > 1) {
                                clearTimeout(pressTimer);
                                return;
                            }

                            const x = e.originalEvent.touches[0].clientX;
                            const y = e.originalEvent.touches[0].clientY;
                            // Cancel if moved more than 10px (Swipe intent)
                            if (Math.abs(x - startX) > 10 || Math.abs(y - startY) > 10) {
                                clearTimeout(pressTimer);
                            }
                        });

                        container.on('touchend touchcancel', 'img', function () {
                            clearTimeout(pressTimer);
                        });

                        // Fallback: Prevent Context Menu just in case CSS fails
                        container.on('contextmenu', 'img', function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            return false;
                        });
                    }

                }
            });
        });

        // Overlay (Cart) - Hidden on mobile via CSS
        const overlay = $('<div>').addClass('fg-overlay').css({
            'top': 'auto',
            'bottom': '4px',
            'right': '4px'
        });

        const cartBtn = $('<button>')
            .addClass('fg-cart-btn')
            .html('Abzug bestellen')
            .css({
                'background': '#000000',
                'border': 'none',
                'border-radius': '0',
                'width': 'auto',
                'height': '26px',
                'padding': '0 10px',
                'display': 'flex',
                'align-items': 'center',
                'justify-content': 'center',
                'cursor': 'pointer',
                'color': '#ffffff',
                'font-family': 'var(--fg-font-family)',
                'font-size': '11px',
                'font-weight': '500',
                'transition': 'opacity 0.2s',
                'opacity': '1'
            })
            .on('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                addPhotoToCart(imgData.image_url);
                $(e.currentTarget).css('background', '#22c55e').css('color', '#fff');
                setTimeout(() => $(e.currentTarget).css('background', '#000000'), 1500);
            });

        cartBtn.hover(
            function () { $(this).css('opacity', '0.9').css('transform', 'scale(1.03)') },
            function () { $(this).css('opacity', '1').css('transform', 'scale(1)') }
        );

        overlay.append(cartBtn);
        link.append(overlay);

        return link;
    }

    // --- ACCESS DENIED HANDLERS ---

    async function handleAccessDenied() {
        const isGuest = !window.FilmGalleryConfig.customerId;
        console.log('handleAccessDenied called, isGuest:', isGuest);

        // Try to get preview data from backend (optional endpoint)
        let previewData = null;
        try {
            const response = await fetch(`https://backend.wiederfaenger.ch/preview/${labServiceId}`);
            if (response.ok) {
                previewData = await response.json();
                console.log('Preview data received:', previewData);
            } else {
                console.log('Preview endpoint returned:', response.status);
            }
        } catch (e) {
            console.warn('Preview fetch failed, using fallback:', e);
        }

        if (isGuest && previewData) {
            console.log('Guest with preview data, has_owner:', previewData.has_owner);
            if (previewData.has_owner === false) {
                // Unclaimed → Show choice between claim and view
                console.log('Showing unclaimed login prompt');
                showUnclaimedLoginPrompt();
            } else {
                // Has owner → Show simple login for gallery
                console.log('Showing gallery login prompt');
                showGalleryLoginPrompt();
            }
        } else if (isGuest) {
            // Fallback for guests without preview data
            console.log('Guest without preview data, showing generic login');
            showGenericLoginPrompt();
        } else {
            // Logged in but no access → Private film
            console.log('Logged in user, showing private film message');
            showPrivateFilmMessage();
        }

        // Hide gallery elements
        console.log('Hiding gallery elements...');
        $grid.hide();
        $doctorContainer.addClass('fg-hidden');

        // Force hide all gallery header elements
        $('.fg-info').hide();
        $('.fg-info').css('display', 'none !important');
        $('.fg-header').hide();
        $('#fg-title').hide();
        $('.fg-download-btn').hide();

        console.log('.fg-info hidden:', $('.fg-info').is('.fg-hidden'));
        console.log('.fg-info count:', $('.fg-info').length);
        $loadingOverlay.fadeOut();
    }

    function showUnclaimedLoginPrompt() {
        const returnUrl = window.location.pathname + window.location.search;
        const loginUrl = window.FilmGalleryConfig.routes.storefront_login_url || window.FilmGalleryConfig.routes.account_login_url;
        const separator = loginUrl.includes('?') ? '&' : '?';
        const html = `
            <div class="fg-access-prompt">
                <h3>Film-QR-Label oder Galerie?</h3>
                <p>Was möchtest du tun?</p>
                
                <div class="fg-access-options">
                    <a href="${loginUrl}${separator}return_to=${encodeURIComponent(returnUrl)}" 
                       class="fg-access-option fg-access-option--primary">
                        <div class="fg-access-option-icon">✨</div>
                        <div class="fg-access-option-content">
                            <strong>Film-QR-Label einlösen</strong>
                            <span>Diesen Film zu meinem Account hinzufügen</span>
                        </div>
                    </a>
                    
                    <a href="${loginUrl}${separator}return_to=${encodeURIComponent(returnUrl)}" 
                       class="fg-access-option">
                        <div class="fg-access-option-icon">👁️</div>
                        <div class="fg-access-option-content">
                            <strong>Nur Bilder ansehen</strong>
                            <span>Galerie ohne Zuordnung betrachten</span>
                        </div>
                    </a>
                </div>
                
                <p class="fg-access-footer">
                    Noch kein Account? 
                    <a href="/account/register">Jetzt registrieren</a>
                </p>
            </div>
        `;

        $('.fg-status-container').removeClass('fg-hidden').html(html);
    }

    function showGalleryLoginPrompt() {
        const returnUrl = window.location.pathname + window.location.search;
        const loginUrl = window.FilmGalleryConfig.routes.storefront_login_url || window.FilmGalleryConfig.routes.account_login_url;
        const separator = loginUrl.includes('?') ? '&' : '?';
        const html = `
            <div class="fg-access-prompt">
                <div class="fg-access-icon">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                        <rect x="5" y="11" width="14" height="10" rx="2" />
                        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                    </svg>
                </div>
                <h3>Galerie ansehen</h3>
                <p>Diese Galerie wurde mit dir geteilt.<br>
                   Melde dich an, um die Bilder zu sehen.</p>
                
                <div class="fg-access-actions">
                    <a href="${loginUrl}${separator}return_to=${encodeURIComponent(returnUrl)}" 
                       class="button button--primary" is="hover-link">
                        <span class="btn-fill" data-fill></span>
                        <span class="btn-text">Jetzt anmelden</span>
                    </a>
                    <a href="/account/register" class="button button--secondary" is="hover-link">
                        <span class="btn-fill" data-fill></span>
                        <span class="btn-text">Registrieren</span>
                    </a>
                </div>
            </div>
        `;

        $('.fg-status-container').removeClass('fg-hidden').html(html);
        initHoverButtons('.fg-status-container');
    }

    function showGenericLoginPrompt() {
        const returnUrl = window.location.pathname + window.location.search;
        const loginUrl = window.FilmGalleryConfig.routes.storefront_login_url || window.FilmGalleryConfig.routes.account_login_url;
        const separator = loginUrl.includes('?') ? '&' : '?';
        const html = `
            <div class="fg-access-prompt">
                <div class="fg-access-icon">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                        <rect x="5" y="11" width="14" height="10" rx="2" />
                        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                    </svg>
                </div>
                <h3>Login erforderlich</h3>
                <p>Melde dich an, um diese Galerie zu sehen.</p>
                
                <div class="fg-access-actions">
                    <a href="${loginUrl}${separator}return_to=${encodeURIComponent(returnUrl)}" 
                       class="button button--primary" is="hover-link">
                        <span class="btn-fill" data-fill></span>
                        <span class="btn-text">Jetzt anmelden</span>
                    </a>
                    <a href="/account/register" class="button button--secondary" is="hover-link">
                        <span class="btn-fill" data-fill></span>
                        <span class="btn-text">Registrieren</span>
                    </a>
                </div>
            </div>
        `;

        $('.fg-status-container').removeClass('fg-hidden').html(html);
        initHoverButtons('.fg-status-container');
    }

    function showPrivateFilmMessage() {
        $('.fg-status-container').removeClass('fg-hidden').html(`
            <div class="fg-status-card">
                <div class="fg-status-icon">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                        <rect x="5" y="11" width="14" height="10" rx="2" />
                        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                    </svg>
                </div>
                <h3 class="fg-status-title">Dieser Film ist privat</h3>
                <p>Dieser Film gehört jemand anderem und ist auf privat eingestellt.</p>
                <a href="https://wiederfaenger.ch" class="button button--primary" is="hover-link">
                    <span class="btn-fill" data-fill></span>
                    <span class="btn-text">Zurück zur Startseite</span>
                </a>
            </div>
        `);
        initHoverButtons('.fg-status-container');
    }

    function showGuestClaimHint() {
        const returnUrl = window.location.pathname + window.location.search;
        const loginUrl = window.FilmGalleryConfig.routes.storefront_login_url || window.FilmGalleryConfig.routes.account_login_url;
        const separator = loginUrl.includes('?') ? '&' : '?';
        const html = `
            <div class="fg-assign-banner fg-guest-hint">
                <h3>💡 Ist das dein Film?</h3>
                <p>Melde dich an, um diesen Film zu deinem Account hinzuzufügen und Updates zu erhalten.</p>
                <a href="${loginUrl}${separator}return_to=${encodeURIComponent(returnUrl)}" 
                   class="button button--secondary" is="hover-link">
                    <span class="btn-fill" data-fill></span>
                    <span class="btn-text">Jetzt anmelden</span>
                </a>
            </div>
        `;

        const $hint = $(html);
        $('.fg-info').append($hint);
        initHoverButtons($hint);
    }

    // --- INFINITE SCROLL ---
    function setupInfiniteScroll() {
        // Scroll container is #PageContainer (not window) because we lock
        // document scroll to prevent Chrome from hiding its address bar.
        var $scrollContainer = $('#PageContainer');
        $scrollContainer.on('scroll', function () {
            if (isLoading || !hasMoreImages) return;

            var scrollTop = $scrollContainer.scrollTop();
            var containerH = $scrollContainer.height();
            var contentH = $scrollContainer[0].scrollHeight;

            if (scrollTop + containerH > contentH - 500) {
                currentPage++;
                loadGallery(currentPage);
            }
        });
    }

    // --- ACTIONS (Download, Share, Modals) ---

    // Mobile Detection
    const isMobile = () => {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || (window.innerWidth < 1024 && 'ontouchstart' in window);
    };

    // Mobile Download Overlay
    const showMobileDownloadOverlay = (url) => {
        // User provided SVG: touch-gesture-svgrepo-com
        // Used exact paths and styles from the file
        const touchIcon = `
                        <svg width="64px" height="64px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10.12,22.31l-5-5a2,2,0,0,1-.58-1.41,2,2,0,0,1,.58-1.4,2,2,0,0,1,1.41-.59,2,2,0,0,1,1.4.59l1.3,1.29V6.48a1.94,1.94,0,0,1,1.71-2,1.89,1.89,0,0,1,2,1.86V12l5,.71a1.87,1.87,0,0,1,1.61,1.85h0a16.9,16.9,0,0,1-1.79,7.58l-.09.17" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M12.94,10.67a4.55,4.55,0,0,0,1.44-1,4.69,4.69,0,1,0-6.64,0,4.59,4.59,0,0,0,1.45,1" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

        const html = `
                        <div class="fg-mobile-dl-overlay">
                            <div class="fg-mobile-dl-content">
                                <div class="fg-mobile-dl-img-wrapper" style="position:relative; width: fit-content; max-width:100%;">
                                    <img src="${url}" class="fg-mobile-dl-image" alt="Download Preview">
                                        <div class="fg-mobile-dl-label" style="position: absolute; bottom: 10px; left: 50%; transform: translateX(-50%); background: rgba(0,0,0,0.6); color: white; padding: 4px 10px; border-radius: 8px; font-size: 1.25rem; pointer-events: none; white-space: nowrap;">
                                            Original (JPG)
                                        </div>
                                </div>
                                <div class="fg-mobile-dl-hint">
                                    <div style="margin-bottom:8px">
                                        ${touchIcon}
                                    </div>
                                    <p>Drück lange auf das Bild oben und wähle <strong>„In Fotos speichern”</strong>.</p>
                                </div>
                                <button class="fg-mobile-dl-close">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                        <path d="M18 6L6 18M6 6l12 12"></path>
                                    </svg>
                                </button>
                            </div>
            </div>
                        `;
        $('body').append(html);

        // Close on Button Click
        $('.fg-mobile-dl-close').one('click', function () {
            $('.fg-mobile-dl-overlay').remove();
        });

        // Close on Backdrop Click (Click outside content)
        $('.fg-mobile-dl-overlay').on('click', function (e) {
            if ($(e.target).hasClass('fg-mobile-dl-overlay')) {
                $(this).remove();
            }
        });
    };

    // Download All (ZIP) - Keep original logic but maybe check mobile?
    // ZIPs work fine on Files app usually.
    $downloadBtn.click(async function () {
        const btn = $(this);
        if (btn.prop('disabled')) return;

        const $progress = btn.find('.fg-dl-progress');
        const $icon = btn.find('svg');

        btn.prop('disabled', true).addClass('is-loading');
        $icon.hide();
        $progress.text('...').css('display', 'inline-flex').fadeTo(200, 1);

        try {
            const zip = new JSZip();
            const total = allImages.length;
            let processed = 0;
            const folder = zip.folder("Wiederfaenger-Film");

            for (let i = 0; i < total; i += 10) {
                const chunk = allImages.slice(i, i + 10);
                await Promise.all(chunk.map(async (img, idx) => {
                    try {
                        const blobRep = await fetch(img.image_url).then(r => r.blob());
                        const fname = `Bild - ${String(i + idx + 1).padStart(3, '0')}.jpg`;
                        folder.file(fname, blobRep);
                    } catch (e) { console.error('DL Error', e); }
                }));
                processed += chunk.length;
                $progress.text(`${Math.round(processed / total * 100)}%`);
            }

            $progress.text('Zippen...');
            const fullZip = await zip.generateAsync({ type: "blob" });
            saveAs(fullZip, "Wiederfaenger-Film.zip");

            $progress.text('100%');
            setTimeout(() => {
                $progress.fadeOut(() => {
                    $icon.fadeIn();
                    btn.removeClass('is-loading');
                });
            }, 800);

        } catch (e) {
            console.error('Download Failed', e);
            alert('Download fehlgeschlagen.');
            $progress.hide();
            $icon.show();
            btn.removeClass('is-loading');
        } finally {
            btn.removeAttr('disabled');
        }
    });

    // Dropdown Actions - Portal Approach (render outside header)
    const $dropdownBtn = $('.fg-dropdown .fg-btn--icon');
    const $originalMenu = $('.fg-dropdown-menu');

    // Create a new menu element appended to body
    const $portalMenu = $originalMenu.clone().attr('id', 'fg-dropdown-portal');
    $('body').append($portalMenu);
    $originalMenu.remove(); // Remove original

    $dropdownBtn.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        // Get button position
        const btnRect = this.getBoundingClientRect();

        // Position menu below button
        $portalMenu.css({
            position: 'fixed',
            top: (btnRect.bottom + 8) + 'px',
            right: (window.innerWidth - btnRect.right) + 'px',
            display: 'block',
            zIndex: 10000
        });
    });

    // Close on click outside
    $(document).on('click', function (e) {
        if (!$(e.target).closest('.fg-dropdown').length) {
            $('.fg-dropdown-menu').hide();
        }
    });

    // Close on option click
    $('.fg-dropdown-menu button, .fg-dropdown-menu a').on('click', function () {
        $('.fg-dropdown-menu').hide();
    });

    // Move modals to body to prevent stacking context isolation/issues on iOS Safari/mobile devices
    $('body').append($('.fg-modal-overlay'));

    // Modals
    const modals = {
        edit: $('#fg-edit-modal'),
        visibility: $('#fg-visibility-modal'),
        share: $('#fg-share-modal'),
        addToCollection: $('#fg-add-to-collection-modal')
    };

    function closeAllModals() { $('.fg-modal-overlay').addClass('fg-hidden'); }
    $('.fg-modal-close, .fg-modal-cancel').click(closeAllModals);

    // Init theme hover animation for modal footer buttons
    if (theme.HoverButton) {
        document.querySelectorAll('.fg-modal-footer .button').forEach(el => {
            new theme.HoverButton(el).load();
        });
    }

    // ── ADD TO COLLECTION MODAL LOGIC ────────────────────────────────
    let currentImageForCollection = null;

    window.openAddToCollectionModal = function (imgData) {
        if (!window.FilmGalleryConfig.customerId) {
            alert('Bitte melde dich an, um Sammlungen zu erstellen.');
            return;
        }
        currentImageForCollection = imgData;

        // Reset state
        $('#fg-add-to-collection-list').empty();
        $('#fg-add-to-collection-empty').addClass('fg-hidden');

        // Show modal and skeleton loader
        const $loader = $('#fg-add-to-collection-loading');
        $loader[0].style.display = 'flex';

        modals.addToCollection.removeClass('fg-hidden');

        // Set cover image on the "Neue Sammlung erstellen" link
        const coverImgUrl = (imgData && imgData.image_url) 
            ? imgData.image_url 
            : (allImages && allImages.length > 0 ? allImages[0].image_url : '');
        if (coverImgUrl) {
            const baseHref = $('#fg-new-collection-link').attr('href').split('?')[0];
            const fromParam = labServiceId ? `&from=${encodeURIComponent(labServiceId)}` : '';
            $('#fg-new-collection-link').attr('href', `${baseHref}?cover=${encodeURIComponent(coverImgUrl)}${fromParam}`);
        }

        const minDelay = new Promise(resolve => setTimeout(resolve, 800));
        const fetchData = fetch(`https://backend.wiederfaenger.ch/mylabservices/${window.FilmGalleryConfig.customerId}`)
            .then(res => res.json());

        Promise.all([fetchData, minDelay])
            .then(([data]) => {
                // Hide skeleton
                $loader[0].style.display = 'none';

                const collections = data.filter(c => c.collection_kind === 'CUSTOM' || c.service_type === 'CUSTOM');

                if (collections.length === 0) {
                    $('#fg-add-to-collection-empty').removeClass('fg-hidden');
                } else {
                    collections.sort((a, b) => {
                        const aName = (a.name || '').toLowerCase();
                        const bName = (b.name || '').toLowerCase();
                        if (aName === 'favoriten' && bName !== 'favoriten') return -1;
                        if (bName === 'favoriten' && aName !== 'favoriten') return 1;
                        return new Date(b.timestamp || b.lab_date) - new Date(a.timestamp || a.lab_date);
                    });
                    collections.forEach(col => {
                        const btn = $('<button>')
                            .addClass('button')
                            .css({
                                'display': 'flex',
                                'justify-content': 'space-between',
                                'align-items': 'center',
                                'width': '100%',
                                'margin-bottom': '8px',
                                'border-radius': '0',
                                'padding': '12px 16px',
                                'background': '#fff',
                                'border': '1px solid #e5e5e5',
                                'text-transform': 'none',
                                'cursor': 'pointer'
                            })
                            .html(`
                                <span style="font-weight: 500; font-family: var(--font-heading-family); font-size: 15px; color: #1a1a1a; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 65%; text-align: left; display: flex; align-items: center; gap: 8px;">
                                    ${(col.name || '').toLowerCase() === 'favoriten' ? '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-heart-icon lucide-heart" style="flex-shrink: 0;"><path d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"/></svg>' : ''}
                                    ${col.name}
                                </span>
                                <span style="background: #1a1a1a; color: #fff; padding: 6px 12px; font-size: 11px; text-transform: uppercase; letter-spacing: 0.05em; font-weight: 500; border-radius: 0;">Hinzufügen</span>
                            `)
                            .hover(function() { $(this).css('background', '#fafafa') }, function() { $(this).css('background', '#fff') })
                            .on('click', function () {
                                const $btn = $(this);
                                const $badge = $btn.find('span:last-child');
                                $badge.text('...').css({'background': '#888'});
                                $btn.prop('disabled', true);

                                const imageId = currentImageForCollection.id || currentImageForCollection._id || currentImageForCollection.image_id || currentImageForCollection.image_url.split('/').pop().split('?')[0];

                                fetch(`https://backend.wiederfaenger.ch/collection/${window.FilmGalleryConfig.customerId}/${col.labservice_id}/image/${imageId}`, {
                                    method: 'PUT'
                                })
                                    .then(res => {
                                        if (!res.ok) throw new Error('Add failed');
                                        $badge.text('Hinzugefügt').css({'background': '#16a34a'});
                                        setTimeout(() => {
                                            $badge.text('Zur Sammlung').css({'background': '#aaa'});
                                            $btn.prop('disabled', false).off('click').on('click', () => {
                                                window.location.href = `${window.FilmGalleryConfig.routes.root_url}pages/dein-film?An6Sr6ze6jNg=${col.labservice_id}`;
                                            });
                                            setTimeout(() => closeAllModals(), 4500);
                                        }, 1200);
                                    })
                                    .catch(err => {
                                        console.error(err);
                                        alert('Fehler beim Hinzufügen. Bitte erneut versuchen.');
                                        $badge.text('Hinzufügen').css({'background': '#1a1a1a'});
                                        $btn.prop('disabled', false);
                                    });
                            });
                        $('#fg-add-to-collection-list').append(btn);
                    });
                }
            })
            .catch(err => {
                console.error(err);
                $loader[0].style.display = 'none';
                $('#fg-add-to-collection-empty').text('Fehler beim Laden der Sammlungen.').removeClass('fg-hidden');
            });
    };

    // Share Button
    $('.share-btn').click(() => {
        const shareUrl = window.location.href;
        $('#share-link-input').val(shareUrl);
        $('#copy-success-msg').addClass('fg-hidden');
        modals.share.removeClass('fg-hidden');
    });

    // Copy Link Button
    $('#copy-link-btn').click(() => {
        const input = document.getElementById('share-link-input');
        const originalValue = input.value;
        
        function showSuccess() {
            // Show success briefly in input field
            input.value = '✓ Link kopiert!';
            input.style.color = '#22c55e'; // green
            input.style.textAlign = 'center';
            
            // Auto-close modal after 1.5 seconds
            setTimeout(() => {
                modals.share.addClass('fg-hidden');
                
                // Reset input silently after modal closes
                setTimeout(() => {
                    input.value = originalValue;
                    input.style.color = '';
                    input.style.textAlign = '';
                }, 300);
            }, 1500);
        }

        function fallbackCopy() {
            try {
                input.select();
                input.setSelectionRange(0, 99999); // For mobile devices
                document.execCommand('copy');
                if (window.getSelection) {
                    window.getSelection().removeAllRanges();
                }
                showSuccess();
            } catch (err) {
                console.error('Fallback: Oops, unable to copy', err);
            }
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(originalValue)
                .then(showSuccess)
                .catch((err) => {
                    console.warn('Clipboard API failed, falling back...', err);
                    fallbackCopy();
                });
        } else {
            fallbackCopy();
        }
    });

    // Edit Name
    $('.edit-name-btn').click(() => {
        // Get only the title text, excluding the ownership indicator
        const titleElement = $title.clone();
        titleElement.find('.fg-ownership-indicator').remove();
        const current = titleElement.text().trim();

        modals.edit.find('h3').text('Name ändern');
        modals.edit.find('input').attr('type', 'text').val(current);
        modals.edit.data('type', 'name').removeClass('fg-hidden');
    });

    // Edit Date
    $('.edit-date-btn').click(() => {
        modals.edit.find('h3').text('Datum ändern');
        modals.edit.find('input').attr('type', 'date').val(window.galleryMetadata.filenameDate || '');
        modals.edit.data('type', 'date').removeClass('fg-hidden');
    });

    // Delete Film
    $(document).off('click', '.delete-film-btn').on('click', '.delete-film-btn', async function () {
        const deleteLabel = isCollection ? 'Sammlung' : 'Film';
        const deleteDetail = isCollection
            ? 'Die Sammlung wird unwiderruflich gelöscht. Deine Bilder in den Filmen bleiben unberührt.'
            : 'Der Film wird aus deinem Konto getrennt. Die Bilder werden innerhalb von 60 Tagen endgültig von unseren Servern gelöscht.';
            
        $('#fg-delete-modal .fg-modal-header h3').text(`${deleteLabel} löschen`);
        $('#delete-modal-text').text(deleteDetail);
        $('#fg-delete-modal').removeClass('fg-hidden');
    });

    $(document).off('click', '#confirm-delete-btn').on('click', '#confirm-delete-btn', async function () {
        const deleteLabel = isCollection ? 'Sammlung' : 'Film';

        if (!labServiceId) {
            alert('Fehler: Keine Lab Service ID gefunden.');
            return;
        }

        if (!customerId) {
            alert('Fehler: Nicht angemeldet.');
            return;
        }

        const $btn = $(this);
        const originalText = $btn.find('.btn-text span').text();
        $btn.prop('disabled', true).find('.btn-text span').text('Wird gelöscht...');

        try {
            const response = await fetch(`https://backend.wiederfaenger.ch/labservice/${customerId}/${labServiceId}`, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' }
            });

            if (response.ok) {
                // Success, don't alert to be seamless, just redirect
                const redirectPage = isCollection ? 'pages/deine-sammlungen' : 'pages/films-collection';
                window.location.href = `${window.FilmGalleryConfig.routes.root_url}${redirectPage}`;
            } else {
                const errorData = await response.json().catch(() => ({}));
                const message = errorData.message || errorData.error || 'Unbekannter Fehler';
                throw new Error(message);
            }
        } catch (err) {
            console.error('Delete Error:', err);
            alert(`Fehler beim Löschen der ${deleteLabel}: ${err.message}`);
            $btn.prop('disabled', false).find('.btn-text span').text(originalText);
            $('#fg-delete-modal').addClass('fg-hidden');
        }
    });


    // Edit Visibility
    $('.edit-visibility-btn').click(() => {
        // Pre-select current visibility
        const currentVisibility = window.galleryMetadata?.visibility || 'PRIVATE';
        $(`input[name = "visibility"][value = "${currentVisibility}"]`).prop('checked', true);
        modals.visibility.removeClass('fg-hidden');
    });

    // Save Edit
    $('.fg-modal-save').click(async function () {
        const modal = $(this).closest('.fg-modal-overlay');

        if (modal.is(modals.edit)) {
            const type = modal.data('type');
            const val = modal.find('input').val();
            
            if (type === 'name' && val.trim().toLowerCase() === 'favoriten') {
                alert('Der Name "Favoriten" ist reserviert. Bitte wähle einen anderen Namen.');
                return;
            }

            if (!val || val.trim() === '') {
                alert('Bitte gib einen gültigen Wert ein.');
                return;
            }

            const endpoint = type === 'name' ? 'name' : 'date';
            const encodedVal = encodeURIComponent(val.trim());
            
            let apiUrl = `https://backend.wiederfaenger.ch/labservice/${endpoint}/${customerId}/${labServiceId}/${encodedVal}`;

            try {
                let res = await fetch(apiUrl, { method: 'PUT' });
                
                // If backend complains about labservice not found, but it's a collection, try the /collection endpoint just in case
                if (res.status === 400 && isCollection) {
                    const altUrl = `https://backend.wiederfaenger.ch/collection/${endpoint}/${customerId}/${labServiceId}/${encodedVal}`;
                    const retryRes = await fetch(altUrl, { method: 'PUT' });
                    if (retryRes.ok) {
                        res = retryRes;
                    }
                }

                if (!res.ok) {
                    const errorText = await res.text();
                    alert(`Fehler vom Server (${res.status}): ${errorText}`);
                    throw new Error('API Error');
                }
                // Optimistic update
                if (type === 'name') $title.text(val);
                else location.reload(); // Date needs formatting, easier to reload or re-parse
                closeAllModals();
            } catch (e) { 
                console.error(e);
            }
        }

        if (modal.is(modals.visibility)) {
            const vis = modal.find('input:checked').val();
            if (!vis) return;
            try {
                await fetch(`https://backend.wiederfaenger.ch/labservice/visibility/${customerId}/${labServiceId}/${vis}`, { method: 'PUT' });
                location.reload();
            } catch (e) {
                alert('Fehler beim Speichern');
            }
        }
    });

    let cachedPrintVariantId = null;

    // Cart Function
    async function addPhotoToCart(url, fancyboxInstance = null) {
        try {
            let variantId = cachedPrintVariantId;
            
            if (!variantId) {
                // Get product handle from global config if available, otherwise use default
                const handle = (window.FilmGalleryConfig && window.FilmGalleryConfig.printProductHandle) ? window.FilmGalleryConfig.printProductHandle : 'ausgedrucktes-foto-10x15cm';
                const productResponse = await fetch(`/products/${handle}.js`);
                
                if (!productResponse.ok) {
                    throw new Error(`Product not found: ${handle}`);
                }
                
                const product = await productResponse.json();
                
                // Find variant with Matt and 10x15
                let variant = product.variants.find(v => 
                    v.option1 === 'Matt' && 
                    (v.option2 === '10x15' || v.option2 === '10x15 cm')
                );
                
                // Fallbacks in case options are swapped or named differently
                if (!variant) {
                    variant = product.variants.find(v => 
                        v.title.includes('Matt') && v.title.includes('10x15')
                    );
                }
                
                // Absolute fallback
                variantId = variant ? variant.id : product.variants[0].id;
                cachedPrintVariantId = variantId;
            }

            // 1. Add to Cart
            const shopifyRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
            const addResponse = await fetch(shopifyRoot + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    items: [{ id: variantId, quantity: 1, properties: { 'Photo URL': url } }]
                })
            });
            const addedData = await addResponse.json();

            // Trigger notification instantly before fetching updated cart
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                detail: {
                    product: addedData.items ? addedData.items[0] : addedData
                }
            }));

            if (fancyboxInstance) {
                fancyboxInstance.close();
            }

            // 2. Fetch updated cart (background update)
            const shopifyRootForCart = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
            const cartResponse = await fetch(shopifyRootForCart + 'cart.js');
            const cart = await cartResponse.json();

            // 3. Trigger Theme Updates
            if (window.theme && window.theme.pubsub) {
                window.theme.pubsub.publish(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
                    source: 'film-gallery',
                    cart: cart
                });
            }

            document.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: { cart: cart, open: true }
            }));

            // Replicate standard Theme cart events
            // This ensures any installed Apps or theme Modals that listen to standard events will open automatically
            if (window.theme && window.theme.pubsub) {
                window.theme.pubsub.publish(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { 
                    source: 'product-form', 
                    productVariantId: variantId, 
                    cart: cart 
                });
            }
            
            document.dispatchEvent(new CustomEvent('cart:refresh', { 
                bubbles: true, 
                detail: { open: false } 
            }));

        } catch (e) {
            console.error('Cart Error', e);
            alert('Fehler beim Hinzufügen zum Warenkorb.');
        }
    }

    // --- HELPER ACTIONS ---
    async function setCoverImage(imageId) {
        if (!imageId) {
            console.error("No Image ID provided for Cover");
            return;
        }

        if (!labServiceId) {
            console.error("Lab Service ID missing (Global Variable)");
            alert("Interner Fehler: Lab Service ID fehlt.");
            return;
        }

        console.log(`Setting cover for LS ${labServiceId} using Image ${imageId}`);

        // Spec: PUT /labservicecover/<labservice_id>/<image_id>
        $.ajax({
            url: `https://backend.wiederfaenger.ch/labservicecover/${labServiceId}/${imageId}`,
            method: 'PUT',
            success: function (response) {
                console.log('Set Cover Response:', response);
                alert('Coverbild erfolgreich aktualisiert!');
            },
            error: function (err) {
                console.error("Error setting cover:", err);
                alert(`Fehler beim Setzen des Covers: ${err.statusText}`);
            }
        });
    }



    async function deleteImage(imageId, fancyboxInstance) {
        if (!imageId) {
            console.error("No Image ID provided for Delete");
            return;
        }

        const customerId = window.FilmGalleryConfig.customerId;

        $.ajax({
            url: `https://backend.wiederfaenger.ch/images/${customerId}/${imageId}`,
            method: 'DELETE',
            success: function () {
                // UI Feedback
                // Simply close the lightbox to avoid Fancybox version compatibility issues with removing slides
                if (fancyboxInstance) {
                    fancyboxInstance.close();
                }

                // Update Global State (Slimmer than reload)
                allImages = allImages.filter(img => {
                    const id = img.id || img.image_id || extractIdFromUrl(img.image_url);
                    return id !== imageId;
                });

                // Remove from Grid
                $(`.fg-grid-item[data-image-id="${imageId}"]`).fadeOut(400, function () {
                    $(this).remove();
                    // Reflow Masonry if possible, or just leave it
                });
            },
            error: function (err) {
                console.error("Error deleting image:", err);
                alert('Fehler beim Löschen des Bildes.');
            }
        });
    }

    // Fancybox Init handled via Click Handler now
    // $('[data-fancybox="gallery"]').fancybox({...});

    // --- FRAME COUNT TOOLTIP ---
    $(document).on('mouseenter', '.fg-frames-tooltip-trigger', function () {
        $(this).find('.fg-frames-tooltip').css('opacity', '1');
    }).on('mouseleave', '.fg-frames-tooltip-trigger', function () {
        $(this).find('.fg-frames-tooltip').css('opacity', '0');
    });

    // Mobile: Tap to toggle
    $(document).on('click touchstart', '.fg-frames-tooltip-trigger', function (e) {
        e.stopPropagation();
        const $tooltip = $(this).find('.fg-frames-tooltip');
        const isVisible = $tooltip.css('opacity') === '1';
        $('.fg-frames-tooltip').css('opacity', '0'); // Hide all others
        $tooltip.css('opacity', isVisible ? '0' : '1');
    });

    // INIT
    loadGallery();

});
